import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { isCreditLensFeatureEnabled } from "../configState/selector";
import { State } from "../state";
import { AuditLogs, HistoryAuditLogs } from "./types";

const create = actionCreatorFactory("AuditLog");

const createAsync = asyncFactory<State>(create);

export interface AuditLogLoadParams {
  id: string;
  from?: number;
  size?: number;
  order?: "asc" | "desc";
  orderBy?: string;
  scope?: string;
}

interface AuditLogLoadSuccessParams {
  auditLog: AuditLogs;
}

export const loadAuditLog = createAsync<
  AuditLogLoadParams,
  AuditLogLoadSuccessParams
>("LOAD", async (params, dispatch, getState) => {
  const auditLog = await api.auditLogs.get(
    params.id,
    isCreditLensFeatureEnabled(getState()),
    params.from,
    params.size,
    params.order,
    params.orderBy,
    params.scope
  );
  dispatch({
    payload: { ...getState(), lastUsed: new Date().getTime().toString() },
    type: "UPDATE_LAST_USED"
  });
  return { auditLog };
});

const loadAuditLogAction = thunkToAction(loadAuditLog.action);
export type LoadAuditLogActionType = typeof loadAuditLogAction;

export interface HistoryAuditLogLoadParams {
  id: string;
}

interface HistoryAuditLogLoadSuccessParams {
  auditLog: HistoryAuditLogs;
}

export const loadHistoryAuditLog = createAsync<
  HistoryAuditLogLoadParams,
  HistoryAuditLogLoadSuccessParams
>("LOAD_V1", async (params, dispatch, getState) => {
  const auditLog = await api.historyAuditLogs.get(
    params.id,
    isCreditLensFeatureEnabled(getState())
  );

  dispatch({
    payload: { lastUsed: new Date().getTime().toString() },
    type: "UPDATE_LAST_USED"
  });
  return { auditLog };
});

const loadHistoryAuditLogAction = thunkToAction(loadAuditLog.action);
export type LoadHistoryAuditLogActionType = typeof loadHistoryAuditLogAction;

export const resetAuditLog = createAsync<any, HistoryAuditLogLoadSuccessParams>(
  "RESET_AUDIT_LOG",
  async (_, dispatch, getState) => {
    return { auditLog: {} };
  }
);

const resetAuditLogAction = thunkToAction(resetAuditLog.action);
export type ResetAuditLogActionType = typeof resetAuditLogAction;



// WEBPACK FOOTER //
// ./src/auditLog/actions.ts